import { clsx } from 'clsx';
import { FC } from 'react';
import LibReactMarkdown, { Components } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { Link } from 'atoms/Link/Link';
import { H1, H2, Span } from 'atoms/Typography';
import { Body } from 'atoms/Typography/Typography';
import styles from './styles.module.css';

export const ReactMarkdown: FC<{
  text?: string;
  className?: string;
  components?: Components;
}> = ({ text, className, components }) => {
  const defaultComponents: Components = {
    h1: ({ children }) => <H1 className={className}>{children}</H1>,
    h2: ({ children }) => <H2 className={className}>{children}</H2>,
    p: ({ children }) => (
      <Body type="md" className={className}>
        {children}
      </Body>
    ),
    span: ({ children, className: elClassName }) => (
      // elClassName includes classNames which were configured in Custom CSS class block
      // for example elClassName uses for aligning text
      <Span className={clsx(className, elClassName && styles[elClassName])}>
        {children}
      </Span>
    ),
    a: ({ children, href }) => (
      <Link href={href as string} className={clsx(styles.link, className)}>
        {children}
      </Link>
    ),
    ul: ({ children }) => (
      <ul className={clsx(styles.list, className)}>{children}</ul>
    ),
    li: ({ children }) => (
      <li className={clsx(styles.listItem, className)}>{children}</li>
    ),
  };

  return (
    <LibReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{ ...defaultComponents, ...components }}
    >
      {text || ''}
    </LibReactMarkdown>
  );
};
